<p-table [columns]="historyCols" [value]="historyData" [showCurrentPageReport]="true" dataKey="id"  [resizableColumns]="true" columnResizeMode="expand">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.show && col.showIcon" [pSortableColumn]="col.field" pResizableColumn [style.max-width]="(col.field == 'transactions' || col.field == 'itemDesc') ? '300px' : none">
                    {{col.header}}
                </th>
                <th *ngIf="col.show && col.showIcon == false" [pSortableColumn]="col.field" style="max-width: 100px;" pResizableColumn>
                    {{col.header}}
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
            <ng-container *ngFor="let col of columns">
                <ng-container *ngIf="col.field !== 'isTracking'">
                    <td *ngIf="col.show && col.showIcon" style="word-break: break-all;white-space: normal;" [style.max-width]="(col.field == 'transactions' || col.field == 'itemDesc') ? '300px' : none">
                        <span pTooltip="{{rowData[col.field]}}" tooltipPosition="top" [ngClass]="{'report-link': col.field === 'transactions' || col.field === 'locationID'}"  (click)="col.field === 'transactions' || col.field === 'locationID' ? detailsView(rowData,col.field === 'locationID' ? 'locationID' : 'txnid') : null">
                            {{rowData[col.field] | shorten: 80}}
                        </span>
                    </td>
                    <td *ngIf="col.show && col.showIcon == false" style="max-width: 100px;word-break: break-all;white-space: normal;">
                        {{rowData[col.field]}}
                    </td>
                </ng-container>
                <ng-container *ngIf="col.field == 'isTracking'">
                    <td>
                        <span *ngIf="selectedProduct?.trackingEnabled" class="btnBars" (click)="loadTrackingOptionsOrg(rowData)">
                            <i class="pi pi-th-large"></i>
                        </span>
                    </td>
                </ng-container>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
            <td colspan="20">
                <div class="p-text-center">{{noHistoryFindOrLoadingText}}</div>
            </td>
        </tr>
    </ng-template>
</p-table>


 <!-- tracking details -->
 <p-dialog header="Tracking Details" [(visible)]="displayTrackingDetails" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Item No.</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{selectedProduct?.itemNo}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Item Description</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div style="word-break: break-all;">{{selectedProduct?.description}}</div>
            </div>
        </div>
    </div>
    <p-table [value]="trackingProducts" responsiveLayout="scroll" [rowsPerPageOptions]="rowsPerPage" [lazy]="true" [paginator]="true"
      [totalRecords]="totalTBRecord" (onPage)="getTxnTrackingData($event)"  [rows]="pageSize" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" dataKey="id" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
                <th id="lot"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'lotChecked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'lotChecked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'lotChecked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'lotChecked','control')=='Currency'">({{utilService.displayName(trackingOptions,'lotChecked','currency')}})</span>
                </th>
                <th id="revision"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'revisionChecked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'revisionChecked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'revisionChecked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'revisionChecked','control')=='Currency'">({{utilService.displayName(trackingOptions,'revisionChecked','currency')}})</span>
                </th>
                <th id="date"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'expirationChecked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'expirationChecked','label')}}</th>
                <th id="serialNo" *ngIf="utilService.showTrackingOption(trackingOptions,'serializedChecked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serializedChecked','label')}}</th>
                <th id="serialNo2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial2Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial2Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial2Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial2Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial2Checked','currency')}})</span>
                </th>
                <th id="serialNo3"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial3Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial3Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial3Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial3Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial3Checked','currency')}})</span>
                </th>
                <th id="serialNo4"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial4Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial4Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial4Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial4Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial4Checked','currency')}})</span>
                </th>
                <th id="serialNo5"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial5Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial5Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial5Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial5Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial5Checked','currency')}})</span>
                </th>
                <th id="serialNo6"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial6Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial6Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial6Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial6Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial6Checked','currency')}})</span>
                </th>
                <th id="serialNo7"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial7Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial7Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial7Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial7Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial7Checked','currency')}})</span>
                </th>
                <th id="serialNo8"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial8Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial8Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial8Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial8Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial8Checked','currency')}})</span>
                </th>
                <th id="serialNo9"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial9Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial9Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial9Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial9Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial9Checked','currency')}})</span>
                </th>
                <th id="serialNo10"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial10Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial10Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial10Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial10Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial10Checked','currency')}})</span>
                </th>
                <th id="serialNo11"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial11Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial11Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial11Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial11Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial11Checked','currency')}})</span>
                </th>
                <th id="serialNo12"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial12Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial12Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial12Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial12Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial12Checked','currency')}})</span>
                </th>
                <th id="serialNo13"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial13Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial13Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial13Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial13Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial13Checked','currency')}})</span>
                </th>
                <th id="serialNo14"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial14Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial14Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial14Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial14Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial14Checked','currency')}})</span>
                </th>
                <th id="serialNo15"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial15Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial15Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial15Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial15Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial15Checked','currency')}})</span>
                </th>
                <th id="serialNo16"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial16Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial16Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial16Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial16Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial16Checked','currency')}})</span>
                </th>
                <th id="serialNo17"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial17Checked',trackingSelectOption)">
                    {{utilService.displayName(trackingOptions,'serial17Checked','label')}}
                    <span *ngIf="utilService.displayName(trackingOptions,'serial17Checked','control')=='Percentage'">(%)</span>
                    <span *ngIf="utilService.displayName(trackingOptions,'serial17Checked','control')=='Currency'">({{utilService.displayName(trackingOptions,'serial17Checked','currency')}})</span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td *ngIf="utilService.showTrackingOption(trackingOptions,'lotChecked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'lotChecked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.lotNo }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.lotNo && product.lotNo | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'revisionChecked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'revisionChecked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.revisionNo }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.revisionNo && product.revisionNo | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'expirationChecked',trackingSelectOption)">
                    {{product.expirationDate | date:
                    'MM/dd/yyyy'}}
                </td>
                <td *ngIf="utilService.showTrackingOption(trackingOptions,'serializedChecked',trackingSelectOption)">
                    {{product.serialNo}}
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial2Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial2Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber2 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber2 && product.serialNumber2 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial3Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial3Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber3 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber3 && product.serialNumber3 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial4Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial4Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber4 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber4 && product.serialNumber4 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial5Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial5Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber5 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber5 && product.serialNumber5 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial6Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial6Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber6 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber6 && product.serialNumber6 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial7Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial7Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber7 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber7 && product.serialNumber7 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial8Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial8Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber8 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber8 && product.serialNumber8 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial9Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial9Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber9 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber9 && product.serialNumber9 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial10Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial10Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber10 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber10 && product.serialNumber10 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial11Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial11Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber11 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber11 && product.serialNumber11 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial12Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial12Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber12 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber12 && product.serialNumber12 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial13Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial13Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber13 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber13 && product.serialNumber13 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial14Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial14Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber14 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber14 && product.serialNumber14 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial15Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial15Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber15 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber15 && product.serialNumber15 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial16Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial16Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber16 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber16 && product.serialNumber16 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
                <td
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial17Checked',trackingSelectOption)">
                    <ng-container *ngIf="utilService.displayName(trackingOptions, 'serial17Checked','control') as controlType">
                        <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNumber17 }}</span>
                        <span *ngIf="controlType === 'DatePicker'">{{ product.serialNumber17 && product.serialNumber17 | date: 'MM/dd/yyyy' }}</span>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td colspan="7" class="p-text-center">
                    {{noTrackingFindOrLoadingText}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-footer>
        <button pButton (click)="displayTrackingDetails=false;" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>


<!-- invoice  popup -->
<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>

<!-- Write check view -->
<app-write-check
    *ngIf="displayWriteCheck && overviewRefId"
    [display]="displayWriteCheck"
    [checkId]="overviewRefId"
    [checkDialogType]="'VIEW'"
    (close)="onCloseWriteCheckDialog($event)">
</app-write-check>

<!-- Expense view -->
<app-add-expense
    *ngIf="displayAddEditExpense && overviewRefId"
    [displayAddEditExpense]="displayAddEditExpense"
    [expenseId]="overviewRefId"
    [type]="'VIEW'"
    (close)="onCloseExpenseDialog($event)">
</app-add-expense>

<!-- Credit Card charge view -->
<app-add-credit-card-charge
    *ngIf="displayCreditCardViewDialog && overviewRefId"
    [displayAddEditCreditCard]="displayCreditCardViewDialog"
    [creditCardId]="overviewRefId"
    [type]="'VIEW'"
    (close)="onCloseCreditChargeDialog($event)">
</app-add-credit-card-charge>

<!-- Inventory Adjustment Details -->
<p-dialog class="customHeader" header="Inventory Adjustment Details" [(visible)]="displayAdjustment" [modal]="true" [responsive]="true" [closable]="true"
    [style]="{ width: '60vw' }" (onHide)="onDialogClose()">
    <div>
        <app-inventory-adjustment-view [inventoryAdjustmentId]="inventoryAdjustmentId"></app-inventory-adjustment-view>
    </div>
    <p-footer *ngIf="isView">
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- Inventory Transfer Details -->
<p-dialog header="Inventory Transfer Details" [(visible)]="displayTransfer" [modal]="true" [responsive]="true"
    [style]="{ width: '60vw' }">
    <app-inventory-transfer-view [inventoryTransferId]="inventorytransferId"></app-inventory-transfer-view>
    <p-footer *ngIf="isView">
        <button type="button" pButton (click)="onDialogClose()" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>
